// extracted by mini-css-extract-plugin
export default {"container":"GridImage_container__+Hupk","spacer":"GridImage_spacer__PRQ1x","gridImg":"GridImage_gridImg__Ah1IP"};